<template>
  <el-dialog class="dialog dialog_external-programms" :visible="true" :append-to-body="true" :close-on-click-modal="true" @close="closeDialog()">
    <div class="dialog-programs dialog__inner">
      <div class="dialog-programs__column dialog-programs__column_aside">
        <div slot="title" class="dialog__head dialog__head_second">
          <div class="dialog__head-inner">
            <h2 class="dialog__title">
              Добавить выгруженную образовательную программу
            </h2>
          </div>
        </div>


        <div style="margin-bottom: 15px;">
          <input type="search" class="input search-form__input" :class="{ 'search-form__input_reset': input && input.length !== 0 }" placeholder="Поиск образовательной программы по названию" v-model.trim="programSearchValue">
        </div>
        <form @submit.prevent="handleSubmitExternalPrograms">
          <div class="programs-list programs-list_vertical dialog-programs__programs-list">
            <div class="programs-list__inner">
              <el-checkbox-group v-model="selection">
                <div class="programs-list__item" v-for="item in this.filteredPrograms" :key="item.id">
                  <div class="programs-list__content">
                    <div class="programs-list__content-item programs-list__content-item_main">
                                            <span class="programs-list__checkbox-wrap" style="display: flex;">
                                                <el-checkbox v-if="orkInfo.editable" class="programs-list__checkbox" :label="item.id"/>

                                                <span class="programs-list__text " v-html="item.name"></span>
                                            </span>
                    </div>

                    <div class="programs-list__content-item" >
                      <div class="programs-list__extra" v-if="item.external">
                        <icon-base viewBox="0 0 21 20" class="programs-list__cloud">
                          <icon-cloud />
                        </icon-base>
                      </div>
                    </div>
                  </div>

                  <footer class="programs-list__footer">
                    Повышение квалификации

<!--                    <icon-base viewBox="0 0 8 14" class="programs-list__more">-->
<!--                      <icon-arrow-right />-->
<!--                    </icon-base>-->
                  </footer>
                </div>
              </el-checkbox-group>
            </div>
          </div>

          <footer class="dialog-programs__footer">
            <button v-if="orkInfo.editable" type="submit" class="btn btn_action ml-auto">
              Добавить выбранные программы
            </button>
          </footer>

        </form>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import dialog from "@/mixins/dialog";
import {mapActions, mapState} from "vuex";

export default {
  mixins: [ dialog ],
  name: "ExternalProgramsDialog",
  props: {
    trainingId: {
      type: Number,
      required: true,
    }
  },
  data() {
    return {
      programSearchValue: '',
      selection: [],
    }
  },
  methods: {
    ...mapActions('editor', ['UPDATE_TRAININGS', 'LOAD_INTERRELATIONS_BY_QUALIFICATION', 'LOAD_ALL_PROGRAMS', 'ATTACH_PROGRAMS_TO_TRAINING']),
    closeDialog() {
      this.$emit('closeExternalProgramsDialog', false);
    },
    async handleSubmitExternalPrograms() {
      const ids = [...new Set(this.selection)];

      const params = {
        trainingId: this.trainingId,
        ids
      };
      await this.ATTACH_PROGRAMS_TO_TRAINING(params);
      this.$emit('closeExternalProgramsDialog', true);
    },
  },
  computed: {
    ...mapState('editor', ['externalPrograms', 'orkInfo']),
    filteredPrograms() {
      if (this.programSearchValue.length > 0) {
        return this.externalPrograms.filter((item) => item.name.toLowerCase().includes(this.programSearchValue.toLowerCase()));
      }
      return this.externalPrograms;
    }
  },
  async mounted() {
    if (this.externalPrograms.length === 0) {
      await this.LOAD_ALL_PROGRAMS();
    }
  }
}
</script>
